<template>
  <h1>Pantalla 1</h1>
</template>

<script>
export default {};
</script>

<style>
</style>